
import { LanguageCode, LanguageCodes, LocalizedSurveyText } from "../../DTOs";
import { basicValidation } from './basicValidation';

export const languageValidation = {
    validateLanguageCode,
    validateLanguageCodeList,
    validateLanguageCodeLists,

    // TODO: Remove these 3
    validateTranslationLanguage,
    validateTranslationLanguageList,
    validateTranslationLanguageLists,
    validateLocalizedSurveyTexts,
    validateLocalizedSurveyText,

    // This should be used to the greatest extent possible. Validates that lists of translations are valid and that they all have the same language codes.
    validateLocalizedSurveyTextLists,
    identicalLanguageCodes
}

function validateLocalizedSurveyTexts(texts:LocalizedSurveyText[])
{
    return texts && 
        Array.isArray(texts) 
        && texts.every(t => validateLocalizedSurveyText(t))
        && basicValidation.arrayStringsAreUnique(texts.map(t => t.languageCode));
}

function validateLocalizedSurveyText(text:LocalizedSurveyText)
{
    return text && typeof(text) === 'object'
        && validateLanguageCode(text.languageCode)
        && basicValidation.resourceText.isValid(text.text, false, 400);
}

function validateLanguageCode(languageCode:LanguageCode)
{
    return languageCode!==null && languageCode!==undefined && typeof(languageCode)==='string' && LanguageCodes.includes(languageCode);
}

// No duplicates
function validateLanguageCodeList(list:LanguageCode[])
{
    return list
        && Array.isArray(list)
        && list.every(l => validateLanguageCode(l)) 
        && basicValidation.arrayStringsAreUnique(list);
}

function identicalLanguageCodes(required:LanguageCode[], test:LanguageCode[])
{
    if(!validateLanguageCodeList(required) || !validateLanguageCodeList(test))
        return false;

    const requiredIdentifier = required.slice().sort().join('|');
    const testIdentifier = test.slice().sort().join('|');
    
    return requiredIdentifier === testIdentifier;
}

// No duplicates, identical lists
function validateLanguageCodeLists(lists:LanguageCode[][])
{
    const getLanguageListIdentifier = (list:LanguageCode[]) =>
    {
        return list.sort().join('|');
    }

    if(lists.length === 0)
        return true;

    if(!validateLanguageCodeList(lists[0]))
        return false;

    for(let i=1; i<lists.length; i++){

        if(getLanguageListIdentifier(lists[0]) !== getLanguageListIdentifier(lists[i]))
            return false;
    }
    return true;
}



function validateTranslationLanguage(itm:{languageCode:LanguageCode})
{
    return itm && validateLanguageCode(itm.languageCode);
}


function validateTranslationLanguageList(list:{languageCode:LanguageCode}[])
{
    return list && validateLanguageCodeList(list.map(l => l.languageCode));
}

function validateTranslationLanguageLists(list:{languageCode:LanguageCode}[][])
{
    return list && validateLanguageCodeLists(list.map(l1 => l1.map(l2 => l2.languageCode)));
}



function validateLocalizedSurveyTextLists(texts:LocalizedSurveyText[][])
{
    if(!texts || !Array.isArray(texts))
        return false;

    if(texts.length === 0)
        return true;

    const firstList = texts[0];
    if(!validateLocalizedSurveyTexts(firstList))
        return false;

    const languages = firstList.map(t => t.languageCode).sort().join('|');

    for(let i=1; i<texts.length; i++)
    {
        const list = texts[i];
        if(!validateLocalizedSurveyTexts(list))
            return false;

        const listLanguages = list.map(t => t.languageCode).sort().join('|');
        if(listLanguages !== languages)
            return false;
    }
}